"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CartValidation = _interopRequireDefault(require("../default/CartValidation"));
var _CommandProductModal = _interopRequireDefault(require("./CommandProductModal"));
var _styles = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const STEPS = {
  CONSUMPTION: 1,
  PRODUCTS: 2,
  RECAP: 3,
  QR_CODE: 4
};
const STEP_LABELS = {
  [STEPS.CONSUMPTION]: 'Mode',
  [STEPS.PRODUCTS]: 'Produits',
  [STEPS.RECAP]: 'Récapitulatif',
  [STEPS.QR_CODE]: 'Paiement'
};
const QR_CODE_SIZE = 280;
const CONSUMPTION_ICONS = {
  default: {
    sur_place: '🍽️',
    emporter: '🥡'
  },
  modern: {
    sur_place: '🍽️',
    emporter: '🥡'
  },
  pizza: {
    sur_place: '🍕',
    emporter: '📦'
  },
  tropical: {
    sur_place: '🏖️',
    emporter: '🌴'
  },
  street: {
    sur_place: '🍔',
    emporter: '🛍️'
  },
  patisserie: {
    sur_place: '☕',
    emporter: '🥐'
  },
  prestige: {
    sur_place: '🍷',
    emporter: '📦'
  },
  neon: {
    sur_place: '🎮',
    emporter: '⚡'
  },
  minimal: {
    sur_place: '🍽️',
    emporter: '🥡'
  },
  demo: {
    sur_place: '✦',
    emporter: '↗'
  },
  latino: {
    sur_place: '🌶️',
    emporter: '🌮'
  }
};
const CommandKioskCore = ({
  templateVariant = 'default',
  styles_properties = {},
  scaleFactor = 1,
  className = '',
  style = {},
  onSubmitOrder,
  project_id: projectId,
  logEvent,
  uri_transformer = url => url,
  ...rest
}) => {
  const products = rest.products ?? [];
  const mergedStyles = (0, _styles.mergeCommandStyles)(templateVariant, styles_properties);
  const labels = (0, _styles.getCommandLabels)(mergedStyles, templateVariant);
  const kioskStyle = (0, _styles.buildCommandKioskStyle)(mergedStyles, scaleFactor, style);
  const [step, setStep] = (0, _react.useState)(STEPS.CONSUMPTION);
  const [consumptionType, setConsumptionType] = (0, _react.useState)(null);
  const [cart, setCart] = (0, _react.useState)([]);
  const [addedId, setAddedId] = (0, _react.useState)(null);
  const [selectedCategoryId, setSelectedCategoryId] = (0, _react.useState)(null);
  const [detailProduct, setDetailProduct] = (0, _react.useState)(null);
  const [checkoutPresentation, setCheckoutPresentation] = (0, _react.useState)({
    mode: 'qr',
    paymentLink: '',
    commandId: '',
    paymentIntentId: ''
  });
  const resetOrder = (0, _react.useCallback)(() => {
    setStep(STEPS.CONSUMPTION);
    setConsumptionType(null);
    setCart([]);
    setDetailProduct(null);
    setCheckoutPresentation({
      mode: 'qr',
      paymentLink: '',
      commandId: '',
      paymentIntentId: ''
    });
    onSubmitOrder?.([]);
    logEvent?.({
      type: 'command_reset',
      cell_id: rest.id
    });
  }, [onSubmitOrder]);

  // Catégories uniques (ordre d'apparition) avec nombre de produits
  const categories = _react.default.useMemo(() => {
    const seen = new Map();
    const activeProducts = products.filter(p => p.is_active);
    activeProducts.forEach(p => {
      (p.categories ?? []).forEach(c => {
        if (!seen.has(c.id)) seen.set(c.id, {
          id: c.id,
          name: c.name,
          count: 0
        });
        seen.get(c.id).count += 1;
      });
    });
    return Array.from(seen.values()).sort((a, b) => a.name.localeCompare(b.name));
  }, [products]);
  const filteredProducts = _react.default.useMemo(() => {
    const active = products.filter(p => p.is_active);
    if (!selectedCategoryId) return active;
    return active.filter(p => (p.categories ?? []).some(c => c.id === selectedCategoryId));
  }, [products, selectedCategoryId]);
  const getDefaultPrice = product => {
    if (!product.prices?.length) return null;
    if (product.default_price_id) {
      const p = product.prices.find(pr => pr.id === product.default_price_id);
      if (p) return p;
    }
    return product.prices[0];
  };
  const addToCart = (0, _react.useCallback)((product, priceOption = null, quantity = 1) => {
    const price = priceOption ?? getDefaultPrice(product);
    const qty = Math.max(1, Number(quantity) || 1);
    if (!price || !product.is_active) return;
    setCart(prev => {
      const existing = prev.find(item => item.productId === product.id && item.priceId === price.id);
      if (existing) {
        return prev.map(item => item === existing ? {
          ...item,
          quantity: item.quantity + qty
        } : item);
      }
      return [...prev, {
        productId: product.id,
        productName: product.name,
        priceId: price.id,
        price: parseFloat(price.price),
        quantity: qty,
        imageUrl: product.images?.[0]?.image_url
      }];
    });
    setAddedId(product.id);
    logEvent?.({
      type: 'command_add_to_cart',
      cell_id: rest.id,
      add_datas: {
        product_id: product.id,
        price_id: price.id
      }
    });
    setTimeout(() => setAddedId(null), 600);
  }, []);
  const updateQuantity = (0, _react.useCallback)((index, delta) => {
    setCart(prev => {
      const item = prev[index];
      const newQty = item.quantity + delta;
      if (newQty <= 0) return prev.filter((_, i) => i !== index);
      return prev.map((it, i) => i === index ? {
        ...it,
        quantity: newQty
      } : it);
    });
    logEvent?.({
      type: 'command_update_quantity',
      cell_id: rest.id,
      add_datas: {
        index: index,
        delta: delta
      }
    });
  }, []);
  const removeFromCart = (0, _react.useCallback)(index => {
    setCart(prev => prev.filter((_, i) => i !== index));
    logEvent?.({
      type: 'command_remove_from_cart',
      cell_id: rest.id,
      add_datas: {
        index: index
      }
    });
  }, []);
  const cartTotal = cart.reduce((acc, item) => acc + item.price * item.quantity, 0);
  const cartCount = cart.reduce((acc, item) => acc + item.quantity, 0);
  const handleConsumptionChoice = (0, _react.useCallback)(type => {
    setConsumptionType(type);
    setStep(STEPS.PRODUCTS);
    logEvent?.({
      type: 'command_back_to_products',
      cell_id: rest.id
    });
  }, []);
  const handleBackToProducts = (0, _react.useCallback)(() => {
    setStep(STEPS.PRODUCTS);
    logEvent?.({
      type: 'command_back_to_products',
      cell_id: rest.id
    });
  }, []);
  const handleValidateOrder = (0, _react.useCallback)(() => {
    if (cart.length === 0) return;
    setStep(STEPS.RECAP);
    logEvent?.({
      type: 'command_validate_order',
      cell_id: rest.id
    });
  }, [cart]);
  const handleProceedToCheckout = (0, _react.useCallback)(details => {
    const isTerminal = details?.kind === 'terminal';
    setCheckoutPresentation({
      mode: isTerminal ? 'terminal' : 'qr',
      paymentLink: details?.paymentLink ?? '',
      commandId: details?.commandId ?? '',
      paymentIntentId: details?.paymentIntentId ?? ''
    });
    if (isTerminal && details?.commandId) {
      onSubmitOrder?.({
        status: 'paid',
        commandId: details.commandId,
        paymentIntentId: details.paymentIntentId,
        consumptionType,
        cart: cart.map(item => ({
          productId: item.productId,
          productName: item.productName,
          priceId: item.priceId,
          price: item.price,
          quantity: item.quantity
        }))
      });
    }
    setStep(STEPS.QR_CODE);
    logEvent?.({
      type: 'command_proceed_to_checkout',
      cell_id: rest.id,
      add_datas: {
        details: details
      }
    });
  }, [cart, consumptionType, onSubmitOrder]);
  const formatPrice = value => typeof value === 'number' ? value.toFixed(2).replace('.', ',') + ' €' : '—';
  const consumptionIcons = CONSUMPTION_ICONS[templateVariant] || CONSUMPTION_ICONS.default;
  const wrapperClassName = ['command-cell-kiosk', templateVariant !== 'default' && `command-cell-kiosk--${templateVariant}`, `command-cell-kiosk--step-${step}`, className].filter(Boolean).join(' ');
  const stepIndicator = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "command-kiosk__steps",
    "aria-label": "\xC9tapes de commande",
    children: [STEPS.CONSUMPTION, STEPS.PRODUCTS, STEPS.RECAP, STEPS.QR_CODE].map(s => /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: `command-kiosk__step ${step >= s ? 'command-kiosk__step--active' : ''} ${step === s ? 'command-kiosk__step--current' : ''}`,
      children: [s, ". ", STEP_LABELS[s]]
    }, s))
  });

  // Step 1 : Sur place / Emporter
  if (step === STEPS.CONSUMPTION) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: wrapperClassName,
      style: kioskStyle,
      "data-scale": scaleFactor,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "command-kiosk__consumption",
        children: [stepIndicator, /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: "command-kiosk__consumption-title",
          children: labels.consumption_title
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "command-kiosk__consumption-choices",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "command-kiosk__consumption-btn",
            onClick: () => handleConsumptionChoice('sur_place'),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__consumption-icon",
              children: consumptionIcons.sur_place
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__consumption-label",
              children: labels.on_site_label
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "command-kiosk__consumption-btn",
            onClick: () => handleConsumptionChoice('emporter'),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__consumption-icon",
              children: consumptionIcons.emporter
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__consumption-label",
              children: labels.takeaway_label
            })]
          })]
        })]
      })
    });
  }

  // Step 2 : Produits
  if (step === STEPS.PRODUCTS) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: wrapperClassName,
      style: kioskStyle,
      "data-scale": scaleFactor,
      children: [detailProduct && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandProductModal.default, {
        name: detailProduct.name,
        subtitle: (detailProduct.categories ?? []).map(category => category.name).join(' · '),
        description: detailProduct.description,
        images: (detailProduct.images ?? []).map(image => image.image_url).filter(Boolean),
        allergens: detailProduct.allergens ?? [],
        ingredients: (detailProduct.ingredients ?? []).map(ingredient => typeof ingredient === 'string' ? ingredient : ingredient?.name).filter(Boolean),
        tags: detailProduct.tags ?? [],
        sections: [detailProduct.nutrition_score ? {
          title: 'Nutri-score',
          items: [String(detailProduct.nutrition_score)]
        } : null, (detailProduct.nutriments ?? []).length ? {
          title: 'Nutriments',
          items: detailProduct.nutriments.map(String)
        } : null].filter(Boolean),
        prices: (detailProduct.prices ?? []).map((price, index) => ({
          id: price.id,
          label: (detailProduct.prices ?? []).length > 1 ? `Prix ${index + 1}` : 'Prix',
          formatted: formatPrice(parseFloat(price.price)),
          raw: price
        })),
        addLabel: labels.add_to_cart_label,
        uri_transformer: uri_transformer,
        onAdd: (price, quantity) => {
          addToCart(detailProduct, price.raw, quantity);
          setDetailProduct(null);
        },
        onClose: () => setDetailProduct(null)
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `command-kiosk__inner ${cart.length > 0 ? 'command-kiosk__inner--cart-open' : ''}`,
        children: [stepIndicator, /*#__PURE__*/(0, _jsxRuntime.jsxs)("header", {
          className: "command-kiosk__header",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "command-kiosk__back",
            onClick: resetOrder,
            "aria-label": "Changer le mode (sur place / emporter)",
            children: ["\u2190 ", consumptionType === 'sur_place' ? labels.on_site_label : labels.takeaway_label]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
            className: "command-kiosk__title",
            children: labels.products_title
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "command-kiosk__cart-badge",
            "data-visible": cartCount > 0,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__cart-count",
              children: cartCount
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              className: "command-kiosk__cart-label",
              children: ["article", cartCount !== 1 ? 's' : '']
            })]
          })]
        }), categories.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "command-kiosk__tabs",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            type: "button",
            className: `command-kiosk__tab ${selectedCategoryId === null ? 'command-kiosk__tab--active' : ''}`,
            onClick: () => setSelectedCategoryId(null),
            children: labels.all_products_tab
          }), categories.map(cat => /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: `command-kiosk__tab ${selectedCategoryId === cat.id ? 'command-kiosk__tab--active' : ''}`,
            onClick: () => setSelectedCategoryId(selectedCategoryId === cat.id ? null : cat.id),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__tab-name",
              children: cat.name
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__tab-count",
              children: cat.count
            })]
          }, cat.id))]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-kiosk__products",
          children: filteredProducts.map((product, index) => {
            const defaultPrice = getDefaultPrice(product);
            const isAdded = addedId === product.id;
            return /*#__PURE__*/(0, _jsxRuntime.jsxs)("article", {
              className: `command-kiosk__card ${isAdded ? 'command-kiosk__card--added' : ''} ${product.highlight ? 'command-kiosk__card--highlight' : ''}`,
              style: {
                animationDelay: `${index * 0.04}s`
              },
              onClick: () => {
                if (defaultPrice) addToCart(product);
              },
              children: [product.highlight && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "command-kiosk__card-badge",
                children: labels.popular_badge
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "command-kiosk__card-image-wrap",
                children: product.images?.[0]?.image_url ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: uri_transformer(product.images[0].image_url),
                  alt: "",
                  className: "command-kiosk__card-image"
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "command-kiosk__card-placeholder",
                  children: "\uD83C\uDF7D\uFE0F"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "command-kiosk__card-body",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                  className: "command-kiosk__card-name",
                  children: product.name
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                  className: "command-kiosk__card-desc",
                  children: product.description || '\u00a0'
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "command-kiosk__card-allergens",
                  children: (product.allergens ?? []).map(a => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    className: "command-kiosk__allergen",
                    title: a.name,
                    children: a.icon
                  }, a.id))
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "command-kiosk__card-footer",
                  children: [defaultPrice ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                    className: "command-kiosk__card-price",
                    children: formatPrice(parseFloat(defaultPrice.price))
                  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "command-kiosk__card-cta",
                    onClick: event => {
                      event.stopPropagation();
                      setDetailProduct(product);
                    },
                    children: labels.details_label
                  })]
                })]
              })]
            }, product.id);
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("aside", {
          className: `command-kiosk__cart ${cart.length > 0 ? 'command-kiosk__cart--open' : ''}`,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "command-kiosk__cart-header",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__cart-title",
              children: labels.cart_title
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "command-kiosk__cart-total",
              children: formatPrice(cartTotal)
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
            className: "command-kiosk__cart-list",
            children: cart.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
              className: "command-kiosk__cart-item",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "command-kiosk__cart-item-info",
                children: [item.imageUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: uri_transformer(item.imageUrl),
                  alt: "",
                  className: "command-kiosk__cart-item-img"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "command-kiosk__cart-item-name",
                  children: item.productName
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
                  className: "command-kiosk__cart-item-price",
                  children: [formatPrice(item.price), " \xD7 ", item.quantity]
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "command-kiosk__cart-item-actions",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  type: "button",
                  className: "command-kiosk__cart-qty-btn",
                  onClick: () => updateQuantity(index, -1),
                  "aria-label": "Diminuer",
                  children: "\u2212"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  className: "command-kiosk__cart-qty",
                  children: item.quantity
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  type: "button",
                  className: "command-kiosk__cart-qty-btn",
                  onClick: () => updateQuantity(index, 1),
                  "aria-label": "Augmenter",
                  children: "+"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  type: "button",
                  className: "command-kiosk__cart-remove",
                  onClick: () => removeFromCart(index),
                  "aria-label": "Supprimer",
                  children: "\xD7"
                })]
              })]
            }, `${item.productId}-${item.priceId}-${index}`))
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            type: "button",
            className: "command-kiosk__cart-validate",
            disabled: cart.length === 0,
            onClick: handleValidateOrder,
            children: [labels.validate_order_prefix, " \xB7 ", formatPrice(cartTotal)]
          })]
        })]
      })]
    });
  }

  // Step 3 : Récapitulatif (CartValidation)
  if (step === STEPS.RECAP) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: wrapperClassName,
      style: kioskStyle,
      "data-scale": scaleFactor,
      children: [stepIndicator, /*#__PURE__*/(0, _jsxRuntime.jsx)(_CartValidation.default, {
        cart: cart,
        cartTotal: cartTotal,
        projectId: projectId,
        userDatas: {
          consumption_type: consumptionType
        },
        labels: labels,
        uri_transformer: uri_transformer,
        onBack: handleBackToProducts,
        onProceedToCheckout: handleProceedToCheckout
      })]
    });
  }

  // Step 4 : QR Code
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: wrapperClassName,
    style: kioskStyle,
    "data-scale": scaleFactor,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "command-kiosk__qrcode",
      children: [stepIndicator, checkoutPresentation.mode === 'terminal' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-kiosk__terminal-success-icon",
          "aria-hidden": true,
          children: "\u2713"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: "command-kiosk__qrcode-title",
          children: labels.payment_success_title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          className: "command-kiosk__qrcode-terminal-msg",
          children: labels.payment_success_message
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: "command-kiosk__qrcode-title",
          children: labels.qr_code_title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "command-kiosk__qrcode-wrap",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: `https://api.qrserver.com/v1/create-qr-code/?size=${QR_CODE_SIZE}x${QR_CODE_SIZE}&data=${encodeURIComponent(checkoutPresentation.paymentLink)}&bgcolor=ffffff&color=1a1a2e`,
            alt: "QR Code paiement",
            className: "command-kiosk__qrcode-img",
            width: QR_CODE_SIZE,
            height: QR_CODE_SIZE
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
        className: "command-kiosk__qrcode-total",
        children: [labels.total_prefix, " : ", formatPrice(cartTotal)]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "command-kiosk__qrcode-back",
        onClick: resetOrder,
        children: labels.new_order_label
      })]
    })
  });
};
var _default = exports.default = CommandKioskCore;